import { render, staticRenderFns } from "./face-swap.vue?vue&type=template&id=5a4140dd&lang=pug&"
import script from "./face-swap.vue?vue&type=script&lang=js&"
export * from "./face-swap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports